import { datadogLogs } from '@datadog/browser-logs'
import { startTransition } from 'react'
import { useShowAppError } from '@/services/appErrors/appErrorAtom'
import { usePriceIntentConfirmMutation } from '@/services/graphql/generated'
import { usePriceCalculatorStep } from '../../usePriceCalculatorStep'
import { usePriceIntentValueOrThrow } from '../../usePriceIntent'

export const useConfirmPriceIntent = () => {
  const priceIntent = usePriceIntentValueOrThrow()

  const priceIntentId = priceIntent.id

  const showError = useShowAppError()
  const { setStep } = usePriceCalculatorStep()
  const [confirmPriceIntent] = usePriceIntentConfirmMutation({
    variables: { priceIntentId },

    onError(error) {
      datadogLogs.logger.warn('Failed to confirm price intent', {
        error,
        priceIntentId,
      })
      showError(error)
      // Prevent form flicker until dialog opens
      startTransition(() => setStep('fillForm'))
    },
    onCompleted(data) {
      const updatedPriceIntent = data.priceIntentConfirm.priceIntent
      if (updatedPriceIntent) {
        setStep('viewOffers')
      } else {
        throw new Error(`UNEXPECTED: price intent not updated without user error (${priceIntentId})`)
      }
    },
  })

  if (!priceIntentId) {
    return () => {
      console.error('tried to confirm PriceIntent before state is ready')
    }
  }

  return confirmPriceIntent
}
